export default __webpack_public_path__ + "static/media/top.33fe13ae.png";